import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import queryString from "query-string";
import {cartRegister} from "../../services/cartRegister";
import {flowRegister} from "../../services/flowRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {themeRegister} from "../../services/themeRegister";
import {dataRegister} from "../../services/dataRegister";
import {videoRegister} from "../../services/videoRegister";
import {BeatLoader} from "react-spinners";
import {userRegister} from "../../services/userRegister";
import {agentRegister} from "../../services/agentRegister";
import {langRegister} from "../../services/langRegister";
import {collectedRegister} from "../../services/collectedRegister";

class SignupAdsFacebookVideo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            query: null,
            theme: null,
            video: null,
            url: null
        };
    };

    componentWillMount() {
        //this.init.data();
        this.init.video();
    }

    init = {
        data: () => {
            let data = themeRegister.getValue();
            let theme = themeRegister.getTheme();

            let theme_data = themeRegister.getValue();
            if(theme_data && theme_data.theme_region){
                if (langRegister.lang() === "sv") {
                    data.agent_description = "Expert på " + theme_data.theme_region;
                } else {
                    data.agent_description = theme_data.theme_region + " Expert";
                }
            }

            let user_data = userRegister.getUser();
            let agent_data = agentRegister.get();
            console.log(user_data);

            if(user_data && user_data.branding_pref){
                data.primary_color = user_data.branding_pref.primary_color;
                data.secondary_color = user_data.branding_pref.secondary_color;
            }

            try {
                if(user_data && user_data.branding_pref){
                    data.disable_infobox = user_data.branding_pref.disable_infobox ? user_data.branding_pref.disable_infobox : false;
                    data.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                    data.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                    data.opacity_infobox = user_data.branding_pref.opacity_infobox ? user_data.branding_pref.opacity_infobox : false;
                }
            } catch (e) {}

            if(user_data && user_data.logo_image){
                data.agency_image = user_data.logo_image;
            }
            if(!data.agent_description && user_data.company_name){
                data.agent_description = user_data.company_name;
            }
            if(!data.agent_description && user_data.billing_company){
                data.agent_description = user_data.billing_company;
            }

            if(agent_data && agent_data.profile_image){
                if(agent_data && agent_data.profile_image){
                    data.agent_image = agent_data.profile_image;
                }
                if(agent_data && agent_data.email){
                    try{
                        let split_email = agent_data.email.split("@");
                        if(Array.isArray(split_email) && split_email.length > 1){
                            data.agency_website = split_email[1];
                        }
                    }catch (e) {}
                }
                if(agent_data && agent_data.name){
                    data.agent_name = agent_data.name;
                }
                if (user_data.fallback_pref && user_data.fallback_pref.phone) {
                    data.agent_phone = user_data.phone;
                } else {
                    if (agent_data && agent_data.phone) {
                        data.agent_phone = agent_data.phone;
                    }
                }
            }else{
                if(user_data && user_data.profile_image){
                    data.agent_image = user_data.profile_image;
                }
                if(user_data && user_data.logo_image){
                    data.agency_image = user_data.logo_image;
                }
                if(user_data && user_data.email){
                    try{
                        let split_email = user_data.email.split("@");
                        if(Array.isArray(split_email) && split_email.length > 1){
                            data.agency_website = split_email[1];
                        }
                    }catch (e) {}
                }
                if(user_data && user_data.name){
                    data.agent_name = user_data.name;
                }
                if(user_data && user_data.phone){
                    data.agent_phone = user_data.phone;
                }
            }

            try {
                if (collectedRegister.getValue("contact").permit) {
                    data.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                }
            } catch (e) {}

            try {
                if (collectedRegister.getValue("qrcode_ads")) {
                    data.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                }
            } catch (e) {}

            let images = imagesRegister.get();
            let items = Array.isArray(flowRegister.getValue("video_items"))?flowRegister.getValue("video_items"):[];
            let location = flowRegister.getValue("display_region");
            let industry = cartRegister.get().industry.name;
            let slides = [];
            for(let i = 0; i < images.length; i++){
                if(images[i].label && slides.length < 9){
                    let slide = {
                        image: "",
                        image_title: null,
                        title: "",
                        description: industry + " | " + location
                    };
                    for(let m = 0; m < items.length; m++){
                        if(!items[m].used && +items[m].label === +images[i].label.id && !slide.image_title){
                            slide.image_title = items[m].title;
                            items[m].used = true;
                            break;
                        }
                    }
                    if(!slide.image_title){
                        for(let m = 0; m < items.length; m++){
                            if(!items[m].used && (!items[m].label && items[m].label !== 0)){
                                slide.image_title = items[m].title;
                                items[m].used = true;
                                break;
                            }
                        }
                    }
                    if(!slide.image_title){
                        slide.image_title = images[i].label.title;
                        slide.title = images[i].label.title;
                    }else{
                        slide.title = slide.image_title;
                    }
                    slide.image = images[i].images.small;
                    slides.push(slide);
                }
            }
            console.log(slides);
            data.slides = JSON.stringify(slides);
            let query = queryString.stringify(data);
            this.setState({
                data: data,
                theme: theme,
                query: query
            }, () => {
                console.log("https://preview." + dataRegister.domain + "/" + salesChannelRegister.get("name")+"/video/"+this.state.theme+"/preview?" + this.state.query);
            });
        },
        video: () => {
            let self = this;
            function check() {
                let value = null;
                value = videoRegister.get();
                if(!value){
                    setTimeout(() => {
                        check();
                    }, 5000)
                }else{
                    try {
                        self.setState({video: value, url: videoRegister.get().url, thumbnail: videoRegister.get().thumbnail});
                    }catch (e) {}
                }
            }
            try {
                let admin_data = cartRegister.getCheckout();
                if(admin_data.admin_video){
                    this.setState({url: admin_data.admin_video, video: true, thumbnail: admin_data.admin_video_thumbnail});
                }else {
                    check();
                }
            }catch (e) {
                check();
            }
        }
    };

    render() {
        //let url = "http://localhost:3001/";
        let url = "https://preview." + dataRegister.domain + "/";
        return (
            <div className={cx(Styles.container)}>
                <div className={Styles.containerItem}>
                    {
                        this.state.query && false &&
                        <iframe className={Styles.iframe} frameBorder={"none"} height={"100%"} width={"100%"} src={url + salesChannelRegister.get("name")+"/video/"+this.state.theme+"/preview?" + this.state.query} allowFullScreen/>
                    }
                    {
                        false &&
                        <audio controls={false} loop={true} autoPlay={true}>
                            <source src={require("../../assets/audio/track.mp3")} type="audio/mp3"/>
                        </audio>
                    }
                    {
                        this.state.video && this.state.url &&
                        <video muted={false} poster={this.state.thumbnail} height={"100%"} width={"100%"} controls={false} loop={true} autoPlay={true} playsinline={true}>
                            <source src={this.state.url} type="video/mp4"/>
                        </video>
                        ||
                        <BeatLoader size={20} color={'var(--first-color)'} loading={true}/>
                    }
                </div>
            </div>
        );
    }
}

export default SignupAdsFacebookVideo;


// WEBPACK FOOTER //
// ./src/components/signup-ads-facebook-video/component.js